import { observer } from 'mobx-react-lite'
import { ColorPicker, TextareaWithLabel, TextFieldWithLabel, Typography } from 'shared/ui'
import { useWidgetChatContext } from 'pages/settings/pages/widgetChat/context/widgetChatContext'
import { WidgetChatCard } from 'pages/settings/pages/widgetChat/ui/WidgetChatCard'
import { WidgetPositionOption } from 'pages/settings/pages/widgetChat/ui/CustomizeBlock/WidgetPositionOption'
import styles from './styles.module.scss'

export const CustomizeBlock = observer(() => {
  const { customizeBlockStore, setIsChatVisible } = useWidgetChatContext()
  const {
    header,
    message,
    opt_in_text,
    button,
    position,
    color,
    setHeader,
    setMessage,
    setOptInText,
    setButton,
    setPosition,
    setColor,
    headerError,
    messageError,
    complianceError,
    buttonError,
  } = customizeBlockStore

  return (
    <div className={styles.customizeBlock}>
      <WidgetChatCard
        blockId='1'
        title='Customize'
        description='Control how your chat widget appears to website visitors.'
      />

      <TextFieldWithLabel
        labelProps={{ label: { text: 'Welcome message' } }}
        textFieldProps={{
          value: message,
          onChange: setMessage,
          InputProps: {
            placeholder: 'Enter welcome message',
            onFocus: () => setIsChatVisible(false),
          },
        }}
        limit={255}
        errorMessage={messageError ?? undefined}
      />

      <TextFieldWithLabel
        labelProps={{ label: { text: 'Header text' } }}
        textFieldProps={{
          value: header,
          onChange: setHeader,
          InputProps: {
            placeholder: 'Enter header text',
            onFocus: () => setIsChatVisible(true),
          },
        }}
        limit={40}
        errorMessage={headerError ?? undefined}
      />

      <div onFocusCapture={() => setIsChatVisible(true)}>
        <TextareaWithLabel
          labelProps={{ label: { text: 'Compliance text', className: styles.complianceTextLabel } }}
          placeholder='Enter compliance text'
          value={opt_in_text}
          onChange={setOptInText}
          limit={500}
          error={complianceError ?? undefined}
          errorType='bottomText'
          rows={1}
          autoResize
          classNameTextarea={styles.complianceTextarea}
        />
      </div>
      <TextFieldWithLabel
        labelProps={{ label: { text: 'Button text' } }}
        textFieldProps={{
          value: button,
          onChange: setButton,
          InputProps: {
            placeholder: 'Enter button text',
            onFocus: () => setIsChatVisible(true),
          },
        }}
        limit={30}
        errorMessage={buttonError ?? undefined}
      />
      <div>
        <Typography
          className={styles.widgetPositionLabel}
          variant='text-input-label-small'
          color='var(--content-primary-secondary)'
          ariaLabel='Widget position label'
          marginBottom={8}
        >
          Widget position
        </Typography>
        <div className={styles.widgetPositionRow}>
          <WidgetPositionOption
            icon='arrowLeftDown'
            label='Left'
            isSelected={position === 'left'}
            onClick={() => setPosition('left')}
            ariaLabel='Position Left'
          />
          <WidgetPositionOption
            icon='arrowRightDown'
            label='Right'
            isSelected={position === 'right'}
            onClick={() => setPosition('right')}
            ariaLabel='Position Right'
          />
        </div>
      </div>
      <div className={styles.primaryColorBlock}>
        <Typography
          className={styles.widgetPositionLabel}
          variant='text-input-label-small'
          color='var(--content-primary-secondary)'
          ariaLabel='Primary color label'
          tag='div'
          marginBottom={8}
        >
          Primary color
        </Typography>
        <ColorPicker color={color} setColor={setColor} />
      </div>
    </div>
  )
})
